import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicItem;
  variant?: 'default' | 'featured';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${comic.id}`}
        className="group relative overflow-hidden rounded-lg cursor-pointer block"
      >
        <div className="aspect-[3/4] w-full">
          <img
            src={comic.coverImage}
            alt={comic.title}
            title={`${comic.title} - 韩国漫画免费阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="inline-block px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-2 whitespace-nowrap">
            {comic.status}
          </span>
          <h3 className="text-base font-heading text-background-50 line-clamp-1">{comic.title}</h3>
          <p className="text-xs text-background-200 mt-1 line-clamp-2">{comic.description}</p>
          <div className="flex items-center gap-3 mt-2 text-xs text-background-300">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
              {formatViews(comic.views)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] w-full bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="flex items-center gap-1 text-xs text-accent-500 whitespace-nowrap">
            <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            {formatViews(comic.views)} 阅读
          </span>
        </div>
      </div>
    </Link>
  );
}